import { DealershipDepartment } from 'services/resources';

export const START_LOADING = 'app/services/DealershipSettings/START_LOADING';

export const CLEAR_NOTIFICATIONS = 'app/services/DealershipSettings/CLEAR_NOTIFICATIONS';
export const GET_DEALERSHIP_SETTINGS_SUCCESS = 'app/services/Settings/GET_DEALERSHIP_SETTINGS_SUCCESS';
export const GET_DEALERSHIP_SETTINGS_FAIL = 'app/services/Settings/GET_DEALERSHIP_SETTINGS_FAIL';
export const UPDATE_DEALERSHIP_SETTINGS_SUCCESS = 'app/services/Settings/UPDATE_DEALERSHIP_SETTINGS_SUCCESS';
export const UPDATE_DEALERSHIP_SETTINGS_FAIL = 'app/services/Settings/UPDATE_DEALERSHIP_SETTINGS_FAIL';
export const UPDATE_PAYMENT_ACCOUNT_LEGAL_ENTITY_SUCCESS =
  'app/services/Settings/UPDATE_PAYMENT_ACCOUNT_LEGAL_ENTITY_SUCCESS';
export const UPDATE_PAYMENT_ACCOUNT_LEGAL_ENTITY_FAIL =
  'app/services/Settings/UPDATE_PAYMENT_ACCOUNT_LEGAL_ENTITY_FAIL';
export const GET_PAYMENT_ACCOUNT_LEGAL_ENTITY_SUCCESS =
  'app/services/Settings/GET_PAYMENT_ACCOUNT_LEGAL_ENTITY_SUCCESS';
export const GET_PAYMENT_ACCOUNT_LEGAL_ENTITY_FAIL = 'app/services/Settings/GET_PAYMENT_ACCOUNT_LEGAL_ENTITY_FAIL';
export const UPDATE_PAYMENT_ACCOUNT_LEGAL_ENTITY_DOCUMENT_SUCCESS =
  'app/services/Settings/UPDATE_PAYMENT_ACCOUNT_LEGAL_ENTITY_DOCUMENT_SUCCESS';
export const UPDATE_PAYMENT_ACCOUNT_LEGAL_ENTITY_DOCUMENT_FAIL =
  'app/services/Settings/UPDATE_PAYMENT_ACCOUNT_LEGAL_ENTITY_DOCUMENT_FAIL';
export const MAILCHIMP_INTEGRATION_SUCCESS = 'app/services/Integration/MAILCHIMP_INTEGRATION_SUCCESS';
export const MAILCHIMP_INTEGRATION_FAIL = 'app/services/Integration/MAILCHIMP_INTEGRATION_FAIL';
export const GET_MAILCHIMP_CUSTOMER_PROGRESS_SUCCESS =
  'app/services/Integration/GET_MAILCHIMP_CUSTOMER_PROGRESS_SUCCESS';
export const GET_MAILCHIMP_CUSTOMER_PROGRESS_FAIL = 'app/services/Integration/MAILCHIMP_INTEGRATION_FAIL';
export const GET_MAILCHIMP_AUTH_URL_SUCCESS = 'app/services/Integration/GET_MAILCHIMP_AUTH_URL_SUCCESS';
export const GET_DEALERSHIP_DEPARTMENTS_SUCCESS = 'app/services/Settings/GET_DEALERSHIP_DEPARTMENTS_SUCCESS';
export const GET_DEALERSHIP_DEPARTMENTS_FAIL = 'app/services/Settings/GET_DEALERSHIP_DEPARTMENTS_FAIL';
export const UPDATE_DEALERSHIP_DEPARTMENT_SUCCESS = 'app/services/Settings/UPDATE_DEALERSHIP_DEPARTMENT_SUCCESS';
export const UPDATE_DEALERSHIP_DEPARTMENT_FAIL = 'app/services/Settings/UPDATE_DEALERSHIP_DEPARTMENT_FAIL';
export const CREATE_DEALERSHIP_DEPARTMENT_SUCCESS = 'app/services/Settings/CREATE_DEALERSHIP_DEPARTMENT_SUCCESS';
export const CREATE_DEALERSHIP_DEPARTMENT_FAIL = 'app/services/Settings/CREATE_DEALERSHIP_DEPARTMENT_FAIL';
export const DELETE_DEALERSHIP_DEPARTMENT_SUCCESS = 'app/services/Settings/DELETE_DEALERSHIP_DEPARTMENT_SUCCESS';
export const DELETE_DEALERSHIP_DEPARTMENT_FAIL = 'app/services/Settings/DELETE_DEALERSHIP_DEPARTMENT_FAIL';

export const startLoading = () => ({
  type: START_LOADING,
});

export const receivedGetDealershipSettingsSuccess = (settings) => ({
  type: GET_DEALERSHIP_SETTINGS_SUCCESS,
  payload: { settings },
});

export const receivedGetDealershipSettingsFail = (errors) => ({
  type: GET_DEALERSHIP_SETTINGS_FAIL,
  payload: { errors },
});

export const receivedUpdateDealershipSettingsSuccess = (settings) => ({
  type: UPDATE_DEALERSHIP_SETTINGS_SUCCESS,
  payload: { settings },
});

export const receivedUpdateDealershipSettingsFail = (errors) => ({
  type: UPDATE_DEALERSHIP_SETTINGS_FAIL,
  payload: { errors },
});

export const receivedGetPaymentAccountLegalEntitySuccess = (paymentAccountLegalEntity) => ({
  type: GET_PAYMENT_ACCOUNT_LEGAL_ENTITY_SUCCESS,
  payload: { paymentAccountLegalEntity },
});

export const receivedGetPaymentAccountLegalEntityFail = (errors) => ({
  type: GET_PAYMENT_ACCOUNT_LEGAL_ENTITY_FAIL,
  payload: { errors },
});

export const receivedUpdatePaymentAccountLegalEntitySuccess = (paymentAccountLegalEntity) => ({
  type: UPDATE_PAYMENT_ACCOUNT_LEGAL_ENTITY_SUCCESS,
  payload: { paymentAccountLegalEntity },
});

export const receivedUpdatePaymentAccountLegalEntityFail = (errors) => ({
  type: UPDATE_PAYMENT_ACCOUNT_LEGAL_ENTITY_FAIL,
  payload: { errors },
});

export const receivedUpdatePaymentAccountLegalEntityDocumentSuccess = (paymentAccountLegalEntity) => ({
  type: UPDATE_PAYMENT_ACCOUNT_LEGAL_ENTITY_DOCUMENT_SUCCESS,
  payload: { paymentAccountLegalEntity },
});

export const receivedUpdatePaymentAccountLegalEntityDocumentFail = (errors) => ({
  type: UPDATE_PAYMENT_ACCOUNT_LEGAL_ENTITY_DOCUMENT_FAIL,
  payload: { errors },
});

export const receivedMailChimpIntegrationSuccess = (settings) => ({
  type: MAILCHIMP_INTEGRATION_SUCCESS,
  payload: { settings },
});

export const receivedMailChimpIntegrationFail = (errors) => ({
  type: MAILCHIMP_INTEGRATION_FAIL,
  payload: { errors },
});

export const receivedMailChimpCustomerProgressSuccess = (mailChimpCustomerUploadProgress) => ({
  type: GET_MAILCHIMP_CUSTOMER_PROGRESS_SUCCESS,
  payload: { mailChimpCustomerUploadProgress },
});

export const receivedMailChimpCustomerProgressFail = (errors) => ({
  type: GET_MAILCHIMP_CUSTOMER_PROGRESS_FAIL,
  payload: { errors },
});

export const receivedClearNotifications = () => ({
  type: CLEAR_NOTIFICATIONS,
});

export const receivedGetMailChimpAuthUrlSuccess = (mailChimpAuthUrl) => ({
  type: GET_MAILCHIMP_AUTH_URL_SUCCESS,
  payload: { mailChimpAuthUrl },
});

export const receivedGetDealershipDepartmentsSuccess = (departments: { results: DealershipDepartment[] }) => ({
  type: GET_DEALERSHIP_DEPARTMENTS_SUCCESS,
  payload: { departments },
});

export const receivedGetDealershipDepartmentsFail = (errors) => ({
  type: GET_DEALERSHIP_DEPARTMENTS_FAIL,
  payload: { errors },
});

export const receivedUpdateDealershipDepartmentSuccess = (department: DealershipDepartment) => ({
  type: UPDATE_DEALERSHIP_DEPARTMENT_SUCCESS,
  payload: { department },
});

export const receivedUpdateDealershipDepartmentFail = (errors) => ({
  type: UPDATE_DEALERSHIP_DEPARTMENT_FAIL,
  payload: { errors },
});

export const receivedCreateDealershipDepartmentSuccess = (department: DealershipDepartment) => ({
  type: CREATE_DEALERSHIP_DEPARTMENT_SUCCESS,
  payload: { department },
});

export const receivedCreateDealershipDepartmentFail = (errors) => ({
  type: CREATE_DEALERSHIP_DEPARTMENT_FAIL,
  payload: { errors },
});

export const receivedDeleteDealershipDepartmentSuccess = (id: number) => ({
  type: DELETE_DEALERSHIP_DEPARTMENT_SUCCESS,
  payload: { id },
});

export const receivedDeleteDealershipDepartmentFail = (errors) => ({
  type: DELETE_DEALERSHIP_DEPARTMENT_FAIL,
  payload: { errors },
});
